import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import { Box } from '@mui/material';

import FileDownloadOutline from '@/assets/icons/FileDownloadOutline';
import Typography from '@/components/Typography';
import { useDataHubUserConfig } from '@/features/DataHub/hooks/useDataHubUserConfig';
import { getExportDateLabel, getExportSinceLabel } from '@/features/DataHub/utils/exportDetails';

export const ExportDetails = ({
  settings,
  exportTimestamp,
  name
}: {
  name?: string;
  exportTimestamp?: number;
  settings: {
    date: {
      from: Date | string | null;
      to: Date | string | null;
    };
    timezone: string;
    includeMetadata: boolean;
  };
}) => {
  const { dateFormatValue } = useDataHubUserConfig();

  const date = getExportDateLabel({
    settings: settings.date,
    timezone: settings.timezone,
    dateFormat: dateFormatValue,
    exportTimestamp
  });

  const since = getExportSinceLabel(exportTimestamp);

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 2,
        justifyContent: 'space-between',
        borderBottomWidth: 1,
        borderColor: 'rgba(248, 248, 248, 0.20)',
        borderBottomStyle: 'solid',
        pb: 2,
        px: 2,
        mt: 1
      }}
    >
      <Typography
        size={14}
        sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
      >
        <FileDownloadOutline sx={{ fontSize: 'inherit' }} />
        {name}
      </Typography>

      <Typography
        size={14}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}
      >
        <DateRangeOutlinedIcon sx={{ fontSize: 'inherit' }} />
        {date}
      </Typography>

      <Typography
        size={14}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}
        textAlign='right'
      >
        <TimerOutlinedIcon sx={{ fontSize: 'inherit' }} />
        {since}
      </Typography>
    </Box>
  );
};
